import React from 'react'
import {Box,Grid, Paper, Typography,CardActionArea } from '@mui/material'

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Image from 'mui-image'

// https://jackandbeyond.com/
// 0000000035555550
// https://thecakestore.co.uk/
const Service = ({name,price, description, image}) => {

  const theme = useTheme()
  const xs_ = useMediaQuery(theme.breakpoints.down('sm'));
  const md_up = useMediaQuery(theme.breakpoints.up('md'));
  return (
    
  //   <Card sx={{ background:"linear-gradient(to bottom, #fff,#fff,#fff,#fff,rgba(210,165,90,0.3),rgba(210,165,90,0.2))",width: {xs:240,md:280}, height:{xs:290,md:340} ,m:2}}>
    
  //     <CardMedia
      
  //       component='img'
  //       height={md_up?"145":"170"}
        
        
  //       image={image}
  //       alt={name}
  //     />
  //     <CardContent>
  //       <Typography color="primary.dark" gutterBottom variant="h5" component="div">
  //         {name}
  //       </Typography>
  //       <Typography variant="body1" color="primary.light">
  //         {price}
  //       </Typography>
  //     </CardContent>
    
  // </Card>
        <Paper 
        sx={{
          background:'linear-gradient(to top,rgb(203,159,78),white,white)',
          boxShadow:1, width:{xs:'220px',md:'280px'}, height:{xs:'270px',md:'340px'}, borderRadius:2, margin:{xs:1,md:4}}}>
            <Box justifyContent='center' my={0} mx={0} height={1}>
              
            <Grid container direction='column'  sx={{ height:1,}}>
              <Grid item >
                <Box sx={{display:'flex' ,justifyContent:'center'}}>
                <img alt={name}src={image} 
              style={{marginTop:0 ,
              //  width:md_up?'280px':'240px', height:md_up?'60%':'50%',
              width:'100%',
              height:md_up?197:156,
                objectFit:'fit'}}/>
                </Box>
              

              </Grid>
              
                  
                  <Grid container item alignItems='space-between'  sx={{height:'42%',px:2,pt:2,pb:1}} >
                    <Grid item>
                    <Typography variant="h3" sx={{fontSize:{xs:24,md:28},}} color='primary.dark' >{name}</Typography>
                    </Grid>
                    
                    <Grid container item alignItems='flex-end' >
                    <Typography fontFamily='Quicksand' variant={md_up?'h5':"h6"} align='left' sx={{width:1}} color='primary.light'>{price}</Typography>
                  </Grid>
                    
                  </Grid>
                  
                  {/* <Grid item xs={4}> */}
                    {/* <Typography align='justify' variant={xs_?'body1':"h6"} >{description}</Typography> */}
                  {/* </Grid> */}
                  
                  
                  
                </Grid>
                
            </Box>
            </Paper>
  
  )
}

export default Service